/**
 * Copyright © 2026 Adnuntius AS.
 */

import {Injectable} from '@angular/core';
import {ApiConfig} from "../../api";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class CrawlerResource {
  private readonly url = ApiConfig.obtain().getVersionedUri('crawler');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  refresh(url: string) {
    return this.send({method: 'GET', url: this.url + "/refresh", params: {url}});
  }

  testConfiguration(testUrl: string, crawlerConfiguration: any) {
    return this.send({method: 'POST', url: this.url, params: {url: testUrl}, body: crawlerConfiguration});
  }

  testContextService(testUrl: string) {
    return this.send({method: 'GET', url: this.url, params: {url: testUrl}});
  }
}
